import React from "react";
import styles from '../styles/Pages.module.css'

const Addtions = () => {
    return (
        <div className={styles.pages}>
            <div className={styles.page}>
                <img src={`${process.env.PUBLIC_URL}/main/5p/5p-4.png`} alt='1page' />
            </div>
        </div>
    )
}

export default Addtions;